import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Player from './components/Player.vue'

Vue.config.productionTip = false
Vue.use(VueRouter);

export const router = new VueRouter({
  mode: 'history',
  routes: [
    {path: '/:licenseKey/:assetId', component: Player}
  ]
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
